export function parseLeanSchemaRef(renderedSchemaName = '') {
    const [typeOrName, schemaName] = getSchemaNameAndType(renderedSchemaName);
    if (schemaName) {
        return {
            schemaName,
            schemaType: typeOrName,
        };
    }
    return {
        schemaName: typeOrName,
    };
}
// if there is no type, returns only the name
const getSchemaNameAndType = (leanSchema) => leanSchema.split('#');
//# sourceMappingURL=utils.js.map